<template>
  <div :class="$style.host">
    <div :class="$style.sidebar">
      <img
        alt="Logo"
        :src="$assets.image('login.png')"
        :class="$style.sidebarLogo"
      >
    </div>
    <div :class="$style.content">
      <div :class="$style.container">
        <img
          alt="Logo"
          :src="$assets.image('logo-blue.png')"
          :class="$style.companyLogo"
        >
        <div :class="$style.title">
          <span>Registration</span>
        </div>
        <distributor-status
          v-if="showDistributorStatuses"
        ></distributor-status>
        <distributor-form-company
          v-if="showFormDistributorCompany"
        ></distributor-form-company>
        <distributor-new-button
          v-if="isStatusNewSelected"
        ></distributor-new-button>
        <distributor-form-email
          v-if="showFormDistributorEmail"
        ></distributor-form-email>
      </div>
      <v-overlay
        absolute
        :value="loading"
        opacity="0.3"
        color="#1976d2"
      >
        <v-progress-circular
          indeterminate
          size="70"
          color="white"
        />
      </v-overlay>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex';
import { SET_DISTRIBUTOR_ERROR } from '@/features/registration/store/modules/registration';
import DistributorStatus from '@/features/registration/components/distributor-status';
import DistributorFormEmail from '@/features/registration/components/distributor-form-email';
import DistributorFormCompany from '@/features/registration/components/distributor-form-company';
import DistributorNewButton from '@/features/registration/components/distributor-new-button';

export default {
  name: 'Distributor',
  components: {
    DistributorStatus,
    DistributorFormEmail,
    DistributorFormCompany,
    DistributorNewButton,
  },
  computed: {
    ...mapState([
      'loading',
      'distributorStatus',
    ]),
    ...mapGetters([
      'isStatusNewSelected',
      'isStatusExistingSelected',
      'showDistributorStatuses',
      'showFormDistributorEmail',
      'showFormDistributorCompany',
    ]),
  },
  methods: mapMutations({
    setDistributorError: SET_DISTRIBUTOR_ERROR,
  }),
};
</script>

<style lang="scss" module>
.host {
  display: flex;
  max-width: 1440px;
  margin: 0 auto;

  @media(min-width: map_get($media-min, 'xsl')) {
    border: 1px solid #dcdcdc;
    border-top: none;
  }

  .sidebar {
    width: 50%;

    @media(max-width: map_get($media-max, 'xsl')) {
      display: none;
    }

    .sidebarLogo {
      width: 100%;
      height: 100%;
    }
  }

  .content {
    padding: 10% 5%;
    text-align: center;
    margin: 0 auto;
    position: relative;

    @media(min-width: map_get($media-min, 'xsl')) {
      width: 50%;
    }

    @media(max-width: map_get($media-max, 'lg')) {
      padding: 5% 0;
    }

    .container {
      padding: 0 50px;

      @media(max-width: map_get($media-max, 'xsl')) {
        padding: 0 15px;
      }
    }

    .companyLogo {
      width: 100%;
      max-width: 200px;
    }

    .title {
      margin-top: 35px;

      > span {
        @include font-rubik-grey(32px, 500, 38px);
      }
    }
  }
}

</style>
